import { AccordionItem, List, Strong, Text } from 'braid-design-system';

export const SectionI = () => (
  <AccordionItem id="section-i" label="Section I: Apply With SEEK">
    <List type="number" start={99}>
      <Text>
        Section I applies if you have chosen to use the Apply with SEEK Solution
        functionality through the SEEK API.
      </Text>
      <Text>
        <Strong>Apply with SEEK Solution</Strong> means the method used to
        distribute Candidate applications to you and Advertisers, using
        information from a Candidate’s Profile to pre-fill the application.
      </Text>
      <Text>
        You must ensure that the following Apply with SEEK functionality is
        enabled for Advertisers via the SEEK API at all times: pre-filling the
        application on the Advertiser’s application form with information from a
        Candidate’s Profile.
      </Text>
    </List>
  </AccordionItem>
);
